module.exports = __webpack_public_path__ + "static/media/sf_pretty.50204f43.jpeg";